import { render, staticRenderFns } from "./StandardTemplateDetails.vue?vue&type=template&id=3506ce40&scoped=true&"
import script from "./StandardTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./StandardTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./StandardTemplateDetails.vue?vue&type=style&index=0&id=3506ce40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506ce40",
  null
  
)

export default component.exports